

import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import Select from "react-select";
import { getDiseasesAction } from "../../../store/actions/DiseasesAction";
import { getContentListAction, sendContentAction } from "../../../store/actions/ContentBankAction"
import placeholder from "../../../../src/assets/images/Placeholder.png"
const MarketingContent = ({ selectedDiseases, onDiseaseChange }) => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const leadDetails = useSelector((state) => state.leadState?.leadDetails)
  const lead_id = leadDetails?.lead_id || id
  const allContent = useSelector((state) => state.contentBank?.contentList || []);
  const diseases = useSelector((state) => state.diseases?.diseases || []);
  // const [selectedDiseases, setSelectedDiseases] = useState([]);

  const filteredContent =
    selectedDiseases.length > 0
      ? allContent.filter((item) =>
        item.diseases?.some((d) =>
          selectedDiseases.some((sd) => sd.value === d.disease_id)
        )
      )
      : allContent;

  const [sentItems, setSentItems] = useState([])
  const [sendingIds, setSendingIds] = useState([]);


  useEffect(() => {
    dispatch(getContentListAction())
  }, [dispatch])
  useEffect(() => {
    dispatch(getDiseasesAction());
  }, [dispatch]);
  const handleSend = async (contentId, contentType) => {
    setSendingIds((prev) => [...prev, contentId]); // show loader

    const payload = {
      content_id: contentId,
      send_type: "Lead",
      lead_id: lead_id,
      patient_id: lead_id,
    };

    const result = await dispatch(sendContentAction(payload));

    if (result?.success) {
      setSentItems((prev) => [...prev, contentId]);
    }

    setSendingIds((prev) => prev.filter((id) => id !== contentId)); // hide loader
  };


  const handlePreview = (item) => {
    let url = ""
    if (item.content_type === "IMAGE" || item.content_type === "PDF") {
      url = item.content_file
    } else if (item.content_type === "VIDEO") {
      url = item.video_link
    }

    if (url) {
      window.open(url, "_blank")
    } else {
      alert("No preview available for this content type or missing link.")
    }
  }

  return (
    <div className="card shadow-none">
      <div className="card-body">
        <div className="mb-3">
          <h5 className="mb-2">Select Disease(s) for Marketing Content</h5>
          <Select
            isMulti
            options={diseases.map((d) => ({
              value: String(d.disease_id),
              label: d.disease_name,
            }))}
            value={selectedDiseases}
            onChange={onDiseaseChange}
            placeholder="Choose disease(s)..."
            classNamePrefix="select"
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: "50px",
                fontSize: "14px",
                borderRadius: "0.5rem",
                borderColor: state.isFocused ? "#007bff" : "#ced4da",
                boxShadow: state.isFocused
                  ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                  : "none",
              }),
              menu: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
          />

        </div>

        <div className="row">
          {filteredContent.length === 0 ? (
            <div className="text-center">
              <p>No content available</p>
            </div>
          ) : (
            filteredContent.map((item) => (
              <div key={item.content_id} className="col-xl-12 mb-3">
                <div className="custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded d-flex justify-content-between align-items-center shadow-sm">
                  <div className="d-flex align-items-center">
                    <div className="media me-3">
                      {item.content_type === "IMAGE" && item.content_file ? (
                        <img
                          alt={item.content_title}
                          width="50"
                          height="50"
                          src={item.content_file}
                          onError={(e) => {
                            e.target.onerror = null
                            e.target.src = placeholder
                          }}
                          className="rounded-circle object-cover"
                        />
                      ) : item.content_type === "VIDEO" ? (
                        <div
                          className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
                          style={{ width: "50px", height: "50px" }}
                        >
                          Video
                        </div>
                      ) : item.content_type === "PDF" ? (
                        <div
                          className="rounded-circle bg-info d-flex align-items-center justify-content-center text-white"
                          style={{ width: "50px", height: "50px" }}
                        >
                          PDF
                        </div>
                      ) : (
                        <img
                          alt="placeholder"
                          width="50"
                          height="50"
                          src={placeholder}
                          className="rounded-circle object-cover"
                        />
                      )}
                    </div>

                    <div>
                      <h5 className="font-weight-bold text-dark">{item.content_title}</h5>
                      <p className="fs-15 mb-1 text-muted">{item.content_type}</p>
                      {item.diseases && item.diseases.length > 0 && (
                        <p className="fs-15 mb-0 text-muted">
                          Disease:{" "}
                          <span className="font-weight-bold">
                            {item.diseases.map((d) => d.disease_name).join(" and ")}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    {(item.content_file || item.video_link) && (
                      <button className="btn btn-sm btn-outline-info me-2" onClick={() => handlePreview(item)}>
                        Preview
                      </button>
                    )}
                    <button
                      className={`btn btn-sm ${sentItems.includes(item.content_id)
                        ? "btn-success"
                        : "btn-primary"
                        }`}
                      onClick={() => handleSend(item.content_id, item.content_type)}
                      disabled={sentItems.includes(item.content_id) || sendingIds.includes(item.content_id)}
                    >
                      {sendingIds.includes(item.content_id) ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : sentItems.includes(item.content_id) ? (
                        "Sent"
                      ) : (
                        "Send"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}

export default MarketingContent
